import { useContext, useEffect, useRef, useState } from "react";
import { ConstantAPISContext } from "../../../context/ConstantAPISContext";
import { showToast } from "../../../helpers/ToastifyHelper";
import TableComponent from "../../../components/OB/TableComponent";
import SearchComponent from "../../../components/OB/SearchComponent";
import Select from "@mui/material/Select";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  TextField,
} from "@mui/material";
import { Form, Formik } from "formik";
import ListHeaderComponent from "../../../components/OB/ListHeaderComponent";
import CevreTemizlikAPI from "../../../apis/OB/Get/CevreTemizlikAPI";
import { useNavigate } from "react-router";
import SessionStorageService from "../../../services/StorageService";
import AbonelerAPI from "../../../apis/OB/Get/AbonelerAPI";
import TableComponent2 from "../../../components/OB/TableComponent2";
import { openFileInNewTab } from "../../../helpers/openFileNewTab";
import EndeksRaporAPI from "../../../apis/OB/Rapor/EndeksRaporAPI";
import { today } from "../../../helpers/TodayDate";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";

const SuAboneEndeksKarti: React.FC = () => {
  const columns = [
    { header: "", field: "", className: "text-center", beyan: 5 },
    { header: "Abone No", field: "aboneNo", className: "text-center" },
    {
      header: "Sözleşme Tarihi",
      field: "sozlesmeTarihi",
      className: "text-center",
    },
    { header: "Abone Tipi", field: "aboneTipi", className: "text-center" },
    {
      header: "Sayaç Markası",
      field: "sayacMarkasi",
      className: "text-center",
    },
    { header: "Sayaç Seri No", field: "sayacSeriNo", className: "text-center" },
    { header: "Adres", field: "aboneAdresi", className: "text-center" },
    { header: "Sayaç Tipi", field: "sayacTipi", className: "text-center" },
    {
      header: "Pafta-Ada-Parsel",
      field: "paftaAdaParsel",
      className: "text-center",
    },
    {
      header: "Ev Sayısı/ İş Sayısı",
      field: "evSayisiIsSayisi",
      className: "text-center",
    },
  ];
  const [data, setData] = useState<any[]>([]);
  const [searchControl, setSearchControl] = useState<boolean>(true);
  const { yilListe } = useContext(ConstantAPISContext);
  const [selectedYear, setSelectedYear] = useState(
    Number(new Date().getFullYear())
  );
  const [selectedGrup, setSelectedGrup] = useState<any>(undefined);
  const [selectedDurum, setSelectedDurum] = useState<any>(3);
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [userControlPopup, setUserControlPopup] = useState<boolean>(false);
  const [isPopupVisible, setIsPopupVisible] = useState<boolean>(false);
  const [popupAciklama, setPopupAciklama] = useState<string>("");

  const [isLoading, setisLoading] = useState<boolean>(false);

  const [kayitBasarili, setKayitBasarili] = useState<boolean>(false);
  const [aciklamaPopUpVisible, setAciklamaPopUpVisible] =
    useState<boolean>(false);
  let user = SessionStorageService.getUserInfo();

  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  };
  useEffect(() => {
    if (!user) {
      setUserControlPopup(true);
    } else {
      setIsLoad(false);
    }
  }, [user]);

  //Aboneler API
  useEffect(() => {
    fetchData(false);
  }, []);

  const fetchData = async (isPass: boolean = true) => {
    if (!(user == null)) {
      setisLoading(true);
      const response = await AbonelerAPI.getAbonelerListe(
        selectedDurum,
        user?.sicilKodu
      );
      setData(response.data);
      setTimeout(() => {
        setisLoading(false);

      }, 100)
      setSearchControl(true);
      if (response.data.length < 1) showToast("Kayıt Bulunamadı!", "warning");
    } else {
      setSearchControl(false);
    }
  };
  //Print Rapor
  const printRapor = (isYadaAboneNo: number) => {  
    EndeksRaporAPI.geExportPdfListe(user?.sicilKodu,isYadaAboneNo)
      .then((res) => {
        if (res.data !== null) {
          openFileInNewTab(
            res.data.reportUrlByteFormat, 
            "-BORDRO BİLGİLERİ - " + today + ".pdf"
          );
        } else {
          // setBorcKontrolResponse({
          //   sonucAciklama: "Pdf indirilirken bir sorun oluştu",
          // });
          // openPopup();
          showToast("Pdf indirilirken bir sorun oluştu", "error");
        }
      })
      .catch((err) => {
        showToast("Pdf indirilirken bir sorun oluştu", "error");
      });
  };
  const handleTemizle = () => {
    setSelectedYear(Number(new Date().getFullYear()));
    setSelectedGrup(undefined);
    setSelectedDurum(1);
  };

  const [value, setValue] = useState(0);
  //Kullanıcı Login control ve yönlendirme
  const navigate = useNavigate();

  //Formik constantları
  const initialValues = {
    //boş kalacak ihtiyaca göre kullanılabilir
  };
  return isLoad ? (
    <>
      <div className="d-flex align-self-stretch justify-content-center align-items-center">
        <CircularProgress />
      </div>
      {userControlPopup && (
        <AciklamaAndUserControlPopup
          open={userControlPopup}
          handleClose={closeUserControlPopup}
          isUserControlPopUp={true}
          description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
        />
      )}
    </>
  ) : (
    <div className="px-4 pt-2">
      <Formik initialValues={initialValues} onSubmit={() => { }}>
        <Form
          id="kayit-form"
          className="d-flex flex-column justify-content-center mb-4"
        >
          <div className="d-flex justify-content-between flex-column flex-xxl-row w-100 gap-3  ml-2 mr-2">
            <div className="d-flex gap-3 w-50 flex-column flex-md-row">
              <div className="form-group w-100 align-self-center">
                <FormControl fullWidth>
                  <TextField
                    id=""
                    label="Sicil No"
                    variant="outlined"
                    size="small"
                    disabled={true}
                    value={user == null ? "" : user.sicilKodu}
                  />
                </FormControl>
              </div>
              <div className="form-group w-100 align-self-center">
                <FormControl fullWidth>
                  <TextField
                    id=""
                    label="Ad Soyad"
                    variant="outlined"
                    size="small"
                    disabled={true}
                    value={user == null ? "" : user.adi + " " + user.soyadi}
                  />
                </FormControl>
              </div>
              <div className="form-group w-100 align-self-center">
                <FormControl fullWidth size="small">
                  <InputLabel id="">Durumu</InputLabel>
                  <Select
                    labelId=""
                    id=""
                    value={selectedDurum || ""}
                    label="Grup"
                    onChange={(e) => {
                      setSelectedDurum(Number(e.target.value || undefined));
                    }}
                  >
                    <MenuItem selected value={3}>
                      Aktif
                    </MenuItem>
                    <MenuItem value={2}>Pasif</MenuItem>
                    <MenuItem value={1}>Hepsi</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
            <SearchComponent
              fetchData={fetchData}
              onTemizle={handleTemizle}
              setData={setData}
            />
          </div>
        </Form>
      </Formik>
      {isLoading ?
        <div className="d-flex w-100 justify-content-center align-items-center" style={{ height: '10rem' }}>

          <CircularProgress />
        </div>
        :
        <TableComponent2
          columns={columns}
          data={data}
          recordsPerPage={10}
          printRaporEndeks={printRapor}
        ></TableComponent2>
      }
    </div>
  );
};

export default SuAboneEndeksKarti;
